// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
div.span-like {
        display: inline; /* Make the div inline */
        padding: 0; /* Remove padding */
        margin: 0; /* Remove margin */
        border: none; /* Remove border */
        background: none; /* Remove background */
        /* Add any other styles as needed */
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
